<template>
	<div class="category-container" :class="{ 'is-virtual': isVirtual }">
		<div class="category-header" :style="'--category-color: '+category.color+';--category-text-color: '+categoryTextColor(category.color)">{{ categoryDisplayName( category.name ) }}</div>
		<div class="category-items">
			<CounterCategoryItem :item="item" :key="item.menu_item_id" v-for="item in category.sortedItems" :taxonomy="category.taxonomy" :fallback-color="category.color" />
		</div>
	</div>
</template>

<script>
import AvailabilityDot from "@/console-new/components/config/menu/AvailabilityDot.vue";
import {useLanguageStore} from "@/shared/stores";
import {isTextColorDark} from "@/shared/helpers/ui";
import {useUserStore} from "@/console-new/stores";
import {useCounterStore} from "@/console-new/stores/counter.store";
import CounterCategoryItem from "@/console-new/components/ops/counter/CounterCategoryItem.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let counterStore = useCounterStore();
		return {getString: languageStore.getString, userStore, counterStore};
	},
	name: "CounterCategory",
	components: {CounterCategoryItem, AvailabilityDot},
	props: {
		isVirtual: {
			type: Boolean,
			default: false,
		},
		category: {
			type: Object,
			required: true,
			validator: (list) => {
				return list.hasOwnProperty("name") && list.hasOwnProperty("color");
			},
		},
	},
	methods: {
		categoryTextColor(color) {
			if(isTextColorDark(color)) {
				return "#000000";
			} else {
				return "#ffffff";
			}
		},
		categoryDisplayName( name ) {
			return ( name !== "" ? name : this.getString('no_name_cat') );
		},
	},
}
</script>

<style scoped lang="scss">

.category-container {
	margin-bottom: var(--orders-padding);

	.category-header {
		width: 82%;
		max-width: 500px;
		padding: 2px 33px 2px 10px;
		background-color: var(--category-color);
		color: var(--category-text-color);
		position: relative;
		display: flex;
		align-items: center;
		border-radius: 7px;
		font-size: 16px;
		white-space: nowrap;
		text-overflow: ellipsis;

		&:before {
			content: "";
			display: block;
			width: 40px;
			height: 100%;
			position: absolute;
			top: 0;
			right: -10px;
			background-color: var(--category-color);
			transform: skew(-15deg);
			border-radius: 7px;
		}
	}

	&.is-virtual {
		.category-header {
			width: calc(100% - 10px);
			max-width: calc(100% - 10px);
			color: var(--color-primary);
			background-color: var(--color-bg-primary-2);

			&:after {
				content: none;
			}
			&:before {
				background-color: var(--color-bg-primary-2);
			}
		}

		.category-items .category-item {
			color: var(--color-primary);
			background-color: var(--color-alpha-1);
			&.deletable {
				box-shadow: 0 1px 3px 1px var(--color-box-shadow-3) inset;
				background-color: var(--color-alpha-4);
			}
		}
	}

	.category-items {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		--items-gap: 10px;
		gap: var(--items-gap);
		margin-top: var(--orders-padding);

		@media (max-width: 700px) {
			--items-gap: 8px;
		}

	}
}

</style>